import { useState } from 'react';
import SectionHeading from '../../ui/SectionHeading/SectionHeading.jsx';
import { faqs } from '../../../data/faqs.js';
import styles from './FAQ.module.css';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section className={styles.section}>
      <div className="container">
        <SectionHeading eyebrow="FAQ" title="Questions, answered" />
        <div className={styles.list}>
          {faqs.map((item, i) => {
            const isOpen = openIndex === i;
            return (
              <div key={item.q} className={styles.item}>
                <button
                  className={styles.question}
                  onClick={() => setOpenIndex(isOpen ? -1 : i)}
                  aria-expanded={isOpen}
                >
                  {item.q}
                  <span className={`${styles.toggle} ${isOpen ? styles.toggleOpen : ''}`} aria-hidden="true">+</span>
                </button>
                <div className={`${styles.answerWrap} ${isOpen ? styles.answerOpen : ''}`}>
                  <p className={styles.answer}>{item.a}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
